import styled from 'styled-components';
import { Image } from '@cashfree-intl/coherent';

export const StyledImage = styled(Image)`
  &.ui.image {
    position: absolute;
    right: 10px;
    top: 10px;
  }
`;
